import { render, staticRenderFns } from "./home_radio.vue?vue&type=template&id=1c7c5356&scoped=true"
import script from "./home_radio.vue?vue&type=script&lang=js"
export * from "./home_radio.vue?vue&type=script&lang=js"
import style0 from "./home_radio.vue?vue&type=style&index=0&id=1c7c5356&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7c5356",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c7c5356')) {
      api.createRecord('1c7c5356', component.options)
    } else {
      api.reload('1c7c5356', component.options)
    }
    module.hot.accept("./home_radio.vue?vue&type=template&id=1c7c5356&scoped=true", function () {
      api.rerender('1c7c5356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileFormPage/home_radio.vue"
export default component.exports